<template>
  <section ref="section" @touchmove.prevent>
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: "HorizontalScreen",
  props: {
    pageRotation: {
      type: Number,
    },
    customStyle: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  mounted() {
    let el = this.$refs.section;
    console.log(el)
    let width = document.documentElement.clientWidth,
        height = document.documentElement.clientHeight;
    //在竖屏状态我们通过添加transform:rotate(90deg)，来让这个页面横过来
    if (window.orientation == null || window.orientation === 180 || window.orientation === 0) {//竖屏状态
      el.style.position = 'fixed';
      el.style.right = '50%'

      if (this.pageRotation == 1) {
        el.style.webkitTransform = el.style.transform = `rotate(270deg)`;
        el.style.bottom = '0'
      } else {
        el.style.webkitTransform = el.style.transform = `rotate(90deg)`;
        el.style.bottom = '-100%'
      }
      el.style.width = `${height}px`;
      el.style.height = `${width}px`;
      el.style.webkitTransformOrigin = el.style.transformOrigin = `${width / 2}px center`;
      //如果已经处于横屏状态就不做其他处理了
    } else if (window.orientation === 90 || window.orientation === -90) {//横屏状态
      el.style.webkitTransform = el.style.transform = `rotate(0)`;
      el.style.width = `${width}px`;
      el.style.height = `${height}px`;
    }

    for (let key in this.customStyle) {
      console.log(key);
      el.style[key] = this.customStyle[key];
    }
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/HorizontalScreen.vue